import React, { useState } from 'react'

import { caption } from '@ui-kit/core/typography'

import SelectionButton from './SelectionButton/index.web'
import type { Value, WebProps } from './types'

const SelectionButtonSet = (props: WebProps): JSX.Element => {
  const [currentValues, setCurrentValues] = useState<Value | Value[] | undefined>(
    props.selectType === 'checkbox' && !props.value ? [] : props.value
  )

  const onOptionCheck = (newValue: Value) => {
    if (Array.isArray(currentValues)) {
      const newArray = [...currentValues]
      const index = newArray.indexOf(newValue)
      if (index >= 0) {
        newArray.splice(index, 1)
      } else {
        newArray.push(newValue)
      }
      setCurrentValues(newArray)
      if (typeof props.onValueChange === 'function') {
        props.onValueChange(newArray)
      }
    } else {
      throw new Error('Assertion: value type of checkbox must be an array')
    }
  }

  const onOptionSelect = (newValue: Value) => {
    if (!Array.isArray(currentValues)) {
      if (newValue === currentValues) {
        return
      }

      setCurrentValues(newValue)

      if (typeof props.onValueChange === 'function') {
        props.onValueChange(newValue)
      }
    }
  }

  const getIsSelected = (optionValue: Value) => {
    if (Array.isArray(props.value)) {
      return props.value?.includes(optionValue)
    }

    return props.value === optionValue
  }

  return (
    <div
      className="grid grid-flow-row gap-y-2.5"
      role={props.selectType === 'radio' ? 'radiogroup' : undefined}
    >
      {props.options
        .filter((option) => !option.hidden)
        .map((option) => (
          <SelectionButton
            {...option}
            key={String(option.value)}
            onClick={props.selectType === 'checkbox' ? onOptionCheck : onOptionSelect}
            isSelected={getIsSelected(option.value)}
            disabled={option.disabled || props.disabled || false}
            selectType={props.selectType}
            hasError={Boolean(props.errorMessage)}
            noOutline={props.noOutline}
          />
        ))}
      {props.errorMessage && <p className={caption({ color: 'uiRed' })}>{props.errorMessage}</p>}
    </div>
  )
}

export default SelectionButtonSet
